module.exports = __webpack_public_path__ + "img/tiktok.37f2662c.svg";